import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import {
  EventScopeProvider,
  type EventScopeMetadata,
} from '../../telemetry/analytics'
import { ProductEventEmitterBinding } from '../../telemetry/ProductEventEmitterBinding'

type AnalyticsIdentityRootState = {
  authorization: {
    partnerId: string | null
    partnerUserId: string | null
    roles: string[]
  }
}

/**
 * Root event scope: the identity every product event carries. Lives inside the
 * Redux Provider because the app renders above it. Product areas nest their
 * own EventScopeProvider under this one for product/section/route keys.
 */
export const AnalyticsIdentityScope = ({
  children,
}: {
  children: ReactNode
}) => {
  const { partnerId, partnerUserId, roles } = useSelector(
    (state: AnalyticsIdentityRootState) => state.authorization
  )
  const roleKey = roles[0]?.toLowerCase()
  const metadata: EventScopeMetadata = {}
  if (partnerId != null) metadata.partner_id = partnerId
  if (partnerUserId != null) metadata.partner_user_id = partnerUserId
  if (roleKey != null) metadata.user_role_key = roleKey

  return (
    <EventScopeProvider metadata={metadata}>
      <ProductEventEmitterBinding />
      {children}
    </EventScopeProvider>
  )
}
